import { render, staticRenderFns } from "./UserMessageBox.vue?vue&type=template&id=8a160b8e&scoped=true&"
import script from "./UserMessageBox.vue?vue&type=script&lang=js&"
export * from "./UserMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./UserMessageBox.vue?vue&type=style&index=0&id=8a160b8e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a160b8e",
  null
  
)

export default component.exports